module.exports = __webpack_public_path__ + "static/media/logo_square_background.437fffab.png";